import { CSSProperties } from "react";
import "./TechnologyWeUseSection.css";
import {
  TechnologyWeUseSectionType,
  TechnologyWeUseItemTypes,
} from "../../../utility/types/generaTypes";
type TechnologyWeUseSectionProps = {
  style?: CSSProperties;
  technologyWeUseSection: TechnologyWeUseSectionType;
};
const TechnologyWeUseSection = ({
  technologyWeUseSection,
  style,
}: TechnologyWeUseSectionProps) => {
  return (
    <section style={style}>
      <div className="app_section">
        <div className="appSection_header_container">
          <h1 className="section_title">{technologyWeUseSection?.title}</h1>
          <p className="section_description">
            {technologyWeUseSection?.description}
          </p>
        </div>

        <div className="technologyWeUseCards_container">
          {technologyWeUseSection.data.map((technologyWeUse, index) => (
            <TechnologyWeUseCard
              key={"TechnologyWeUseCard" + index}
              technologyWeUse={technologyWeUse}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

type TechnologyWeUseCardProps = {
  technologyWeUse: TechnologyWeUseItemTypes;
};

const TechnologyWeUseCard = ({ technologyWeUse }: TechnologyWeUseCardProps) => {
  return (
    <div className="technologyWeUseCard_container">
      <h2>{technologyWeUse?.title}</h2>
      {technologyWeUse?.description && <p>{technologyWeUse?.description}</p>}
    </div>
  );
};

export default TechnologyWeUseSection;
